import React from "react";

import { formatTimeDisplay } from "../../utils/playbackUtils";
import { getEventOwnerLine } from "../../utils/ownerLine";

import { ClockIcon } from "./PlaybackIcons";
import TimePickerButton from "./TimePickerButton";
import DateCalendarPicker from "./DateCalendarPicker";

export default function PlaybackSearchPanel({
  cameras,
  loadingCameras,
  selectedCameraId,
  onSelectedCameraIdChange,

  selectedDate,
  onSelectedDateChange,
  recordedDates,
  visibleCalendarMonth,
  onVisibleCalendarMonthChange,

  startTime,
  onStartTimeChange,
  endTime,
  onEndTimeChange,

  loadingQuery,
  onSearch,
  cameraMsg,
}) {
  return (
    <div className="rounded-2xl bg-white p-3 shadow-md dark:bg-[#1F2A3B]">
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-5 xl:gap-3">
        <div className="min-w-0 xl:col-span-1">
          <label className="mb-2 block text-sm font-semibold">카메라</label>
          <select
            value={selectedCameraId}
            onChange={(e) => onSelectedCameraIdChange(e.target.value)}
            className="h-[52px] w-full min-w-0 rounded-[18px] border border-gray-300 bg-white px-4 py-2 text-center text-[16px] font-medium text-gray-900 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-[#0F172A] dark:text-white sm:h-11 sm:rounded-xl sm:px-3 sm:text-sm"
          >
            {loadingCameras ? (
              <option value="">불러오는 중...</option>
            ) : cameras.length === 0 ? (
              <option value="">카메라 없음</option>
            ) : (
              cameras.map((cam) => (
                <option key={cam.id} value={cam.id}>
                  {/* "지점 / 팀 / 이름 / 차량번호".
                      값이 하나도 없으면 기존 표기로 돌아간다. */}
                  {getEventOwnerLine(cam) ||
                    `${cam.camName}${cam.camNo ? ` (CAM ${cam.camNo})` : ""}${
                      cam.ownerLoginId ? ` / ${cam.ownerLoginId}` : ""
                    }`}
                </option>
              ))
            )}
          </select>
        </div>

        <div className="min-w-0 xl:col-span-1">
          <label className="mb-2 block text-sm font-semibold">날짜</label>
          <DateCalendarPicker
            selectedDate={selectedDate}
            onChange={onSelectedDateChange}
            recordedDates={recordedDates}
            visibleMonth={visibleCalendarMonth}
            onVisibleMonthChange={onVisibleCalendarMonthChange}
          />
        </div>

        <div className="min-w-0 xl:col-span-1">
          <label className="mb-2 block text-sm font-semibold">시작 시간</label>
          <TimePickerButton
            value={startTime}
            onChange={(e) => onStartTimeChange(e.target.value)}
            icon={<ClockIcon />}
            displayValue={formatTimeDisplay(startTime)}
          />
        </div>

        <div className="min-w-0 xl:col-span-1">
          <label className="mb-2 block text-sm font-semibold">종료 시간</label>
          <TimePickerButton
            value={endTime}
            onChange={(e) => onEndTimeChange(e.target.value)}
            icon={<ClockIcon />}
            displayValue={formatTimeDisplay(endTime)}
          />
        </div>

        <div className="flex min-w-0 items-end xl:pt-[26px]">
          <button
            type="button"
            onClick={onSearch}
            disabled={loadingQuery}
            className="h-[52px] w-full rounded-[18px] bg-blue-600 px-4 py-2 text-[16px] font-semibold text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-blue-300 dark:bg-blue-500 dark:hover:bg-blue-600 dark:disabled:bg-blue-300 sm:h-11 sm:rounded-xl sm:text-sm"
          >
            {loadingQuery ? "조회 중..." : "조회"}
          </button>
        </div>
      </div>

      {cameraMsg && (
        <div className="mt-3 text-sm">
          <div className="break-words text-red-500">{cameraMsg}</div>
        </div>
      )}
    </div>
  );
}